import Footer from "@/components/footer";
import { Toaster } from "@/components/ui/sonner";
import { Outlet } from "react-router";
import { loadSsoAppConfig } from "@/redux/sso/sso-api";
import { ssoAuthActions } from "@/redux/sso/sso-slice";
import { useAppDispatch } from "@/hooks/redux-hooks";
import { loadChannels } from "@/redux/system/channel-api";
import { loadTxtypes } from "@/redux/system/txtype-api";
import { systemActions } from "@/redux/system/system-slice";
import { getAuthenticatedUser } from "@/redux/auth/auth-api";
import type { Route } from "../+types/root";
import { authActions } from "@/redux/auth/auth-slice";

export async function loader({ request }: Route.LoaderArgs) {
  try {
    const appRes = await loadSsoAppConfig();
    const channelRes = await loadChannels();
    const txTypesRes = await loadTxtypes();

    let nettpayUser: User | null = null;
    let authenticated = false;

    try {
      const cookies = request.headers.get("cookie");
      if (cookies) {
        const authUserRes = await getAuthenticatedUser(request);
        nettpayUser = await authUserRes.json();
        if (nettpayUser?.id) authenticated = true;
      }
    } catch (error) {}

    return {
      appConfig: await appRes.json(),
      txTypes: await txTypesRes.json(),
      channels: await channelRes.json(),
      nettpayUser: nettpayUser,
      authenticated,
    };
  } catch (error) {
    console.log(error);
    throw new Error("Internal Server Error: Unable to load resource");
  }
}

export default function PageLayout({
  loaderData: { appConfig, txTypes, channels, nettpayUser, authenticated },
}: any) {
  const dispatch = useAppDispatch();

  if (txTypes) dispatch(systemActions.setTxTypes(txTypes));
  if (channels) dispatch(systemActions.setChannels(channels));
  if (appConfig) dispatch(ssoAuthActions.setAppConfig(appConfig));
  if (authenticated && nettpayUser) dispatch(authActions.setUser(nettpayUser));

  return (
    <div className="flex max-h-screen overflow-hidden justify-between flex-col">
      <Outlet />
      <Footer />
      <Toaster />
    </div>
  );
}
